import React, { lazy } from 'react';
import { autobind } from 'core-decorators';
import { Row, Col } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import Input from 'src/componentes/input';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import ColaboradorSimplificadoLookup from 'src/lookups/ColaboradorSimplificadoLookup';
import Panel from 'src/componentes/panel';
import PanelCollapse from 'src/componentes/panel-collapse';
import { capitalizeFirstLetter } from 'src/utils/string';
import TabelaRelacionamento from '../processo-filho';
import TabelaProcessosAssociados from '../processos-associados';
import ArquivoUploadAnexos from 'src/componentes/arquivo-upload/anexos';
import http from 'src/services/httpService';
import DesenharCampoCustomizado from '../../../item/campo-customizado/componentes/desenhar';
import AnaliseSwot from '../componentes/AnaliseSwot/AnaliseSwot';
import FiltroItemRelatorioPowerBI from 'src/paginas/item/edit/resumo/filtro-relatorio-powerbi';
import MatrizRiscoLookup from 'src/lookups/matriz-risco';
import RiscoListView from '../../risco/RiscoListView';
import ContentManager from 'src/componentes/content-manager';
import ItemList from 'src/paginas/item';
import Confirm from 'src/componentes/message-box/confirm';
import DataInicioTermino from 'src/paginas/formula/componentes/inicio-termino';
import { TIPO_ITENS } from 'src/utils/constants';
import SearchRiskDrawer from './SearchRiskDrawer';
import SearchRiskDrawerSchema from './SearchRiskDrawer/search-schema';
const Historico = lazy(() => import('src/paginas/versao-alteracao'));
import { getConfiguration } from 'src/services/commonRequests';

@autobind
class ProcessoResumoEdit extends React.Component {
  loadConfiguracaoRisco() {
    getConfiguration('ItemConfiguracaoRisco')((configuracao) => {
      this.setState({ ...this.state, configuracaoRisco: configuracao });
    })();
  }

  constructor(props) {
    super(props);

    this.state = {
      configuracoes: [],
      configuracaoRisco: {},
      refreshRiscoList: 0,
      ignoredIds: [],
      addedIds: [],
    };

    http
      .get(`/ItemConfiguracaoProcesso/ObterConfiguracoes`)
      .then((response) => {
        this.setState({
          configuracoes: response.data,
        });
      });

    this.loadConfiguracaoRisco();
  }

  handleAreaChange(value) {
    this.props.model.getModel('area').requestChange(value);

    let usarCodigoArea = this.props.model.getModel(
      'utilizarCodigoAreaParaMascara'
    ).value;
    if (usarCodigoArea) {
      let novoCodigoItem =
        value.idIntegracao + this.props.model.getModel('idIntegracao').value;
      this.props.model.getModel('idIntegracao').requestChange(novoCodigoItem);
    }
  }

  renderFiltroRelatorioPowerBI(disabled, model) {
    return (
      model.getModel('itemRelatorioPowerBI').value && (
        <FiltroItemRelatorioPowerBI
          model={model.getModel('itemRelatorioPowerBI')}
          disabled={disabled}
          itemId={model.getModel('id').value}
          tipoItemId={model.getModel('tipo').value?.id}
        />
      )
    );
  }

  handleSelect(itens) {
    const modelItens = this.props.model.getModel('riscosAssociados');

    let itensAtuais =
      modelItens?.value?.length > 0 ? modelItens.value.map((d) => d) : [];
    itensAtuais.map((item) => itens.push(item));

    this.setState({ addedIds: [...itens.map((i) => i.id)] });

    modelItens.requestChange(itens);

    this.refresh();
  }

  refresh() {
    this.setState({ refreshRiscoList: this.state.refreshRiscoList + 1 });
  }

  handleNewClick() {
    const modelItens = this.props.model.getModel('riscosAssociados');

    ContentManager.addContent(
      <ItemList
        showModal
        select
        multiple
        tipoItem={TIPO_ITENS.RISCO}
        searchDrawerComponent={
          <SearchRiskDrawer
            intl={this.props.intl}
            configuracao={this.state?.configuracaoRisco}
          />
        }
        searchDrawerSchema={SearchRiskDrawerSchema}
        selectedCallback={(itens) => this.handleSelect(itens)}
        selectedIds={modelItens.value}
        parameters={{ tiposIdsSelecionados: [TIPO_ITENS.RISCO] }}
      />
    );
  }

  handleDeleteConfirm(itemRemove) {
    const { intl } = this.props;
    ContentManager.addContent(
      <Confirm
        message={capitalizeFirstLetter(
          intl.formatMessage({ id: 'label.desejaMesmoExcluirEsseRegistro' })
        )}
        handleConfirm={() => this.handleRemoveAssociation(itemRemove)}
      />
    );
  }

  handleRemoveAssociation(itemRemove) {
    const modelItens = this.props.model.getModel('riscosAssociados');
    const updatedItens = modelItens.value.filter(
      (item) => item.id !== itemRemove.id
    );
    modelItens.requestChange(updatedItens);

    this.setState({
      refreshRiscoList: this.state.refreshRiscoList + 1,
      ignoredIds: [...this.state.ignoredIds, itemRemove.id],
    });
  }

  addNewRiskItem = (item) => {
    const modelItens = this.props.model.getModel('riscosAssociados');
    const newItem = {
      id: item.id,
      nome: item.nome,
      probabilidade: item.probabilidade,
      severidade: item.severidade,
      score: item.score,
    };

    let itensAtuais =
      modelItens?.value?.length > 0 ? modelItens.value.map((d) => d) : [];
    itensAtuais.push(newItem);
    modelItens.requestChange([...itensAtuais]);
  };
  render() {
    const { model, resources, disabled } = this.props;
    const podeEditar = disabled ? true : !model.getModel('podeEditar').value;
    const isNew = model?.getModel('id')?.value < 1;
    const { configuracoes } = this.state;
    const bloquearCodigoAutomatico =
      disabled ||
      (configuracoes &&
        configuracoes.permitirAlterarCodigoAutomatico == false &&
        configuracoes.utilizarCodigoAutomatico == true)
        ? true
        : false;
    const utilizarCodigoAutomatico =
      configuracoes && configuracoes.utilizarCodigoAutomatico;

    return (
      <div>
        <Panel header={<FormattedMessage id="label.informacoesBasicas" />}>
          <Row>
            <Col md={configuracoes.exibirAnexarEmProcessos ? 5 : 6}>
              <Input
                disabled={disabled}
                required
                model={model.getModel('nome')}
              />
            </Col>
            <Col md={3}>
              <ItemOrganizacaoLookup
                disabled={disabled}
                required
                model={{
                  label: capitalizeFirstLetter(resources.area),
                  value: model.getModel('area').value,
                  requestChange: this.handleAreaChange,
                  errors: model.getModel('area').errors,
                }}
              />
            </Col>
            <Col md={3}>
              <Input
                disabled={bloquearCodigoAutomatico}
                required={!utilizarCodigoAutomatico}
                model={model.getModel('idIntegracao')}
              />
            </Col>

            {configuracoes.exibirAnexarEmProcessos && (
              <Col md={1} className={'d-flex align-items-center'}>
                <ArquivoUploadAnexos
                  disabled={disabled}
                  tipoAnexo={this.props.tiposAnexos.item}
                  formGroupStyle={{ marginBottom: 0 }}
                  model={model.getModel('arquivos')}
                />
              </Col>
            )}
          </Row>
          <Row>
            <Col md={3}>
              <ColaboradorSimplificadoLookup
                disabled={disabled}
                required
                multi
                model={{
                  label: capitalizeFirstLetter(resources.responsaveis),
                  value: model.getModel('responsaveis').value,
                  requestChange: model.getModel('responsaveis').requestChange,
                  errors: model.getModel('responsaveis').errors,
                }}
              />
            </Col>
            <Col md={3}>
              <MatrizRiscoLookup
                style={{ height: '42px' }}
                controlStyle={{ height: '43px' }}
                clearable
                model={{
                  label: capitalizeFirstLetter(
                    this.props.intl.formatMessage(
                      { id: 'matrizRisco' },
                      { risco: resources.risco }
                    )
                  ),
                  value: model.getModel('matrizRisco').value,
                  requestChange: model.getModel('matrizRisco').requestChange,
                }}
              />
            </Col>
            <Col>
              <DataInicioTermino
                viewMode="days"
                style={{ height: '45px' }}
                height={43}
                disabled={disabled}
                autoFormatDate={true}
                showClear={false}
                mesAno={false}
                dataInicio={model.getModel('dataInicioItem')}
                dataTermino={model.getModel('dataTerminoItem')}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Input
                disabled={disabled}
                type="textarea"
                model={model.getModel('descricao')}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {model.getModel('camposCustomizados').value &&
                model.getModel('camposCustomizados').value.length > 0 && (
                  <DesenharCampoCustomizado
                    model={model.getModel('camposCustomizados')}
                    colValue={
                      model.getModel('camposCustomizados').value.length <= 4
                        ? 12 / model.getModel('camposCustomizados').value.length
                        : 3
                    }
                    disabled={disabled}
                  />
                )}
            </Col>
          </Row>
        </Panel>
        {model.value &&
          model.value.id != 0 &&
          configuracoes.associarItensImpactados && (
            <PanelCollapse
              header={capitalizeFirstLetter(
                this.props.intl.formatMessage(
                  { id: 'labelProcessosAssociados' },
                  { processos: resources.processos }
                )
              )}
              open={false}
            >
              <Row>
                <Col md={12} style={{ marginTop: 20 }}>
                  <TabelaProcessosAssociados
                    itemIdIgnorar={model.value.id}
                    allowNew={!disabled}
                    disabled={disabled || podeEditar}
                    model={model}
                  ></TabelaProcessosAssociados>
                </Col>
              </Row>
            </PanelCollapse>
          )}
        {model.value && model.value.id != 0 && (
          <PanelCollapse
            header={capitalizeFirstLetter(resources.processosfilhos)}
            open={false}
          >
            <Row>
              <Col md={12} style={{ marginTop: 20 }}>
                <TabelaRelacionamento
                  itemIdIgnorar={model.value.id}
                  allowNew={!disabled}
                  disabled={disabled || podeEditar}
                  model={model}
                ></TabelaRelacionamento>
              </Col>
            </Row>
          </PanelCollapse>
        )}
        {model?.value?.id != null && model?.value?.id > 0 && (
          <PanelCollapse
            header={resources.riscos}
            open={false}
            loadChildrenOnOpen={true}
          >
            <Row>
              <Col>
                <RiscoListView
                  handleSelectRisk={disabled ? null : this.handleNewClick}
                  ehItemImpactado={true}
                  afterSave={this.addNewRiskItem}
                  select={false}
                  allowNew={!disabled}
                  showColumns={[
                    'idIntegracao',
                    'responsaveis',
                    'nome',
                    'area',
                    'tags',
                    'severidadeInerente',
                    'severidade',
                    'probabilidadeInerente',
                    'probabilidade',
                    'descricaoGrauRiscoInerente',
                    'descricaoGrauRisco',
                    'scoreInerente',
                    'score',
                    'descricoesCausas',
                    'descricoesConsequencias',
                    'descricoesPontoControle',
                  ]}
                  disabled={disabled || !podeEditar}
                  showCustomFields={false}
                  showSearchButton={true}
                  ignoreFiltroId={true}
                  usarFiltroSalvo={false}
                  showSearch={false}
                  hideHead={true}
                  selectedItems={model.getModel('riscosAssociados').value}
                  ignoreTag={false}
                  params={{
                    processoId: model.value.id,
                    ignorarIds: this.state.ignoredIds,
                    addedIds: this.state.addedIds,
                  }}
                  handleRemoveAssociation={(item) =>
                    this.handleDeleteConfirm(item)
                  }
                  processoId={model.value.id}
                  saved={this.state.refreshRiscoList}
                  refreshList={() => this.refresh()}
                />
              </Col>
            </Row>
          </PanelCollapse>
        )}
        {model.value &&
          model.value.id != 0 &&
          configuracoes.utilizarAnaliseSwot && (
            <PanelCollapse header={<FormattedMessage id="labelAnaliseSWOT" />}>
              {model.getModel('id').value && (
                <AnaliseSwot
                  disabled={disabled}
                  processoId={model.getModel('id').value}
                  intl={this.props.intl}
                />
              )}
            </PanelCollapse>
          )}
        {model.value &&
          model.value.id != 0 &&
          this.renderFiltroRelatorioPowerBI(disabled, model)}
        {!isNew && (
          <PanelCollapse
            open={false}
            header={this.props.intl.formatMessage({ id: 'label.historico' })}
            loadChildrenOnOpen={true}
          >
            <Historico
              url={`/Processo/ObterHistorico`}
              id={model.getModel('id').value}
            />
          </PanelCollapse>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    configuracao: state.user.configuracao,
    modulosComprados: state.user.licenca.modulos,
    tiposAnexos: state.user.tiposAnexos,
  };
}
export default injectIntl(connect(mapStateToProps)(ProcessoResumoEdit));
